/* oxlint-disable grafit-oxlint/no-tailwind-font-classes -- Typography 2 migration */
import { Label } from "@grafit/design-system/components/molecules/label";
import { ToggleGroup, ToggleGroupItem } from "@grafit/design-system/components/molecules/toggle-group";
import { useLocalStorage } from "@grafit/design-system/hooks/use-local-storage";
import { Trans } from "@grafit/i18n";
import { isPreview } from "@grafit/shared/utils/envs.front";
import { useCallback } from "react";
import { z } from "zod";
import { MagicLinkSignIn } from "./magic-link-sign-in";
import { OTPSignIn } from "./otp-sign-in";
import { PasswordSignIn } from "./password-sign-in";

const authMethodSchema = z.enum(["password", "otp", "magic-link"]);

const AUTH_METHOD_PREFERENCE_KEY = "auth-method-preference";
const isPreviewEnv = isPreview();
export const OtherMethods = ({ validatedEmail }: { validatedEmail: string }) => {
  const isOnboarding = window.location.pathname.includes("onboarding");
  const [authMethod, setAuthMethod] = useLocalStorage(AUTH_METHOD_PREFERENCE_KEY, "otp", authMethodSchema);
  const handleAuthMethodChange = useCallback(
    (value: string) => {
      const parsed = authMethodSchema.safeParse(value);
      if (parsed.success) {
        setAuthMethod(parsed.data);
      }
    },
    [setAuthMethod],
  );

  return (
    <div>
      <div className="mb-4 space-y-3">
        <Label className="font-medium text-sm">
          <Trans i18nKey="auth.sign-in.method-switch.label" />
          {isPreviewEnv && (
            <div className="my-2 text-red-500">
              <Trans i18nKey="auth.sign-in.enable-third-party-cookie" />
            </div>
          )}
        </Label>
        <ToggleGroup type="single" value={authMethod} onValueChange={handleAuthMethodChange} className="flex w-full">
          <ToggleGroupItem value="otp" className="flex-1">
            <Trans i18nKey="auth.sign-in.method-switch.otp" />
          </ToggleGroupItem>
          <ToggleGroupItem value="magic-link" className="flex-1">
            <Trans i18nKey="auth.sign-in.method-switch.magic-link" />
          </ToggleGroupItem>
          <ToggleGroupItem value="password" className="flex-1">
            <Trans i18nKey="auth.sign-in.method-switch.password" />
          </ToggleGroupItem>
        </ToggleGroup>
      </div>

      {authMethod === "password" && (
        <PasswordSignIn email={validatedEmail} disabled={false} isOnboarding={isOnboarding} />
      )}
      {authMethod === "otp" && <OTPSignIn email={validatedEmail} disabled={false} isOnboarding={isOnboarding} />}
      {authMethod === "magic-link" && (
        <MagicLinkSignIn email={validatedEmail} disabled={false} isOnboarding={isOnboarding} />
      )}
    </div>
  );
};
